import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, ReplaySubject, tap } from 'rxjs';
import { SignInRequestDTO, SignInResponseDTO } from './sign-in-dtos';
import { Role } from '../../../feature/settings/models/role';
import { LottoUser } from '../../../components/views/sign-in/user.model';

@Injectable()
export class SignInService {
  private currentUser: LottoUser;

  private rolesSubject: ReplaySubject<Role[]> = new ReplaySubject<Role[]>();

  public readonly initiatedUser: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private http: HttpClient) {}

  public signInToApp(idToken: string): Observable<SignInResponseDTO> {
    const body: SignInRequestDTO = { token: idToken };

    return this.http.post<SignInResponseDTO>('/security/login', body, {}).pipe(
      tap((value) => {
        this.rolesSubject.next(value.roles);
      })
    );
  }

  setCurrentUser(u: LottoUser, firstTime: boolean = false) {
    this.currentUser = u;

    if (firstTime) {
      this.initiatedUser.next(true);
    }
  }

  getCurrentUser(): LottoUser {
    return this.currentUser;
  }

  getRoles(): Observable<Role[]> {
    return this.rolesSubject.asObservable();
  }
}
